const styles = (theme) => {
  return {
    container: {
      maxWidth: '56vh',
      maxHeight: '75vh',
      display: 'grid',
      position: 'relative',
      margin: 'auto',
      justifyContent: 'center',
      alignItems: 'center'
    },
    '@media (max-width: 640px)': {
      container: {
        gridTemplateColumns: '320px'
      }
    },
    '@media screen and (max-width: 1080px)': {
      container: {
        maxWidth: '50vh',
        maxHeight: '56vh',
        display: 'grid',
        position: 'relative',
        margin: 'auto',
        justifyContent: 'center',
        alignItems: 'center'
      }
    },
    '@media screen and (max-device-width: 1280px) and (max-device-height: 800px)':
      {
        container: {
          maxWidth: '950px',
          maxHeight: '40vh'
        }
      }
  };
};

export default styles;
